/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

interface InputWithSuffixArgs {
  id: string;
  suffix: string;
  inputClassNames: string;
  inputWrapperClassNames: string;
  suffixClassNames: string;
  value: string;
  type: string;
  errors: string;
  errorType: string;
  onInput: (value: string) => unknown;
  onBlur: () => unknown;
}

export default class InputWithSuffix extends Component<InputWithSuffixArgs> {
  @tracked inputWithoutSuffix = '';

  get inputClassNames() {
    return this.args.inputClassNames ?? 'fly-form-control';
  }

  get suffixClassNames() {
    return this.args.suffixClassNames ?? 'pt-0.5 px-1';
  }

  constructor(owner: unknown, args: InputWithSuffixArgs) {
    super(owner, args);

    // Replace the suffix from the value: this will be the editable value
    let pattern = new RegExp(`${this.args.suffix}$`, 'i');
    this.inputWithoutSuffix = this.args.value.replace(pattern, '');
  }

  @action
  onInput(value: string) {
    this.inputWithoutSuffix = value;
    this.args.onInput(`${value}${this.args.suffix}`);
  }
}
